import React, { useEffect, useRef, useState } from 'react';
import Form, {
    ButtonItem,
    SimpleItem,
    GroupItem,
    Label,
    EmailRule,
    RequiredRule,
    AsyncRule,
    
} from 'devextreme-react/form';
import useAuthorization from '../../hooks/useAuthorization';
import { Button, NumberBox, Validator, DateBox } from 'devextreme-react';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import { useSelector,useDispatch } from 'react-redux';
import { setAppInfo } from '../../store/app/appActions';
import { DivFormColumns } from '../../components/form/DivForm';
import { dataAccess, editorOptionsNumberBox, formatDate, resources } from '../../data/app';

const App = () => {

    const { authorized } = useAuthorization([resources.app, dataAccess.access ]);
    const [saving, setSaving] = useState({
        loading : false,
        text : 'Guardar'
    });

    const dispatch = useDispatch();
    const { appInfo } = useSelector(store => store); 

    const [app, setApp] = useState({...appInfo});   

    const onFormSubmit = (e) => {

        e.preventDefault();

        setSaving({loading : true, text:'Guardando...'});
        http('about/set-info').asPost(app).then(resp => {

            notify('Datos actualizados');
            setSaving({loading : false, text:'Guardar'});
            dispatch(setAppInfo(app));
            
        }).catch(err => {

            notify(err, 'error');
            setSaving({loading : false, text:'Guardar'});

        });
    }

    useEffect(() => {
        setApp({...app, ...appInfo});
    }, [appInfo]);

    return authorized(
        <div className="container small">
            <form onSubmit={onFormSubmit}>
                <div className="dx-fieldset">
                    <div className="dx-fieldset-header">Configuración de cursos</div>
                    <DivFormColumns title='Precio del curso CATEGORIA 1'
                        description="Ingrese el precio del curso de la categoria 1">                        
                        <NumberBox                            
                            value={app.priceCat1}                           
                            onValueChanged={e => setApp(app => ({ ...app, priceCat1: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio del curso CATEGORIA 2'
                        description="Ingrese el precio del curso de la categoria 2">                        
                        <NumberBox
                            value={app.priceCat2}
                            onValueChanged={e => setApp(app => ({ ...app, priceCat2: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio del curso CATEGORIA 1 + CATEGORIA 2'
                        description="Ingrese el precio del curso de la categoria 1 + categoria 2">
                        <NumberBox
                            value={app.priceCat1_Cat2}
                            onValueChanged={e => setApp(app => ({ ...app, priceCat1_Cat2: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio del curso CATEGORIA 3'
                        description="Ingrese el precio del curso de la categoria 3">
                        <NumberBox
                            value={app.priceCat3}
                            onValueChanged={e => setApp(app => ({ ...app, priceCat3: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    
                    <DivFormColumns title='Precio del curso CATEGORIA 1 + CATEGORIA 3'
                        description="Ingrese el precio del curso de la categoria 1 + categoria 3">
                        <NumberBox
                            value={app.priceCat1_Cat3}
                            onValueChanged={e => setApp(app => ({ ...app, priceCat1_Cat3: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio del curso CATEGORIA 2 + CATEGORIA 3'
                        description="Ingrese el precio del curso de la categoria 2 + categoria 3">
                        <NumberBox
                            value={app.priceCat2_Cat3}
                            onValueChanged={e => setApp(app => ({ ...app, priceCat2_Cat3: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio del curso CATEGORIA 1 + CATEGORIA 2 + CATEGORIA 3'
                        description="Ingrese el precio del curso de la categoria 1 + categoria 2 + categoria 3">
                        <NumberBox
                            value={app.priceCat1_Cat2_Cat3}
                            onValueChanged={e => setApp(app => ({ ...app, priceCat1_Cat2_Cat3: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>


                    <div className="dx-fieldset-header">Configuración de Arqueo</div>
                    <DivFormColumns title='Inicio de arqueo'
                        description="Seleccione la fecha del inicio de proceso, dejar en vacio si aplica desde siempre">                        
                        <DateBox                            
                            value={app.processesInitDate}  
                            showClearButton={true}
                            openOnFieldClick={true}
                            displayFormat={formatDate}
                            onValueChanged={e => setApp(app => ({ ...app, processesInitDate: e.value }))}                            
                        >                            
                        </DateBox>
                    </DivFormColumns>
                    <Button 
                        icon='save'
                        text={saving.text} 
                        disabled={saving.loading}
                        type="default"                     
                        useSubmitBehavior={true}>
                    </Button>
                </div>
            </form>           
        </div>
    );
}

export default App;
